// frontend/src/api/CNASTDPIGEFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCNASTDPIGEFiles = async () => {
  try {
    const response = await api.get("/cna-std-pige-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA STD PIGE file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNASTDPIGEFileById = async (id) => {
  try {
    const response = await api.get(`/cna-std-pige-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA STD PIGE file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNASTDPIGEFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-std-pige-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNASTDPIGEFiles = async (query) => {
  try {
    const response = await api.get(`/cna-std-pige-files/?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching CNA STD PIGE files with query "${query}":`, error);
    throw error;
  }
};

// Crear un nuevo archivo
export const createCNASTDPIGEFile = async (data) => {
  try {
    const response = await api.post("/cna-std-pige-files/", data);
    return response.data;
  } catch (error) {
    console.error("Error creating CNA STD PIGE file:", error);
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNASTDPIGEFile = async (id, data) => {
  try {
    const response = await api.put(`/cna-std-pige-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA STD PIGE file with ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNASTDPIGEFile = async (id) => {
  try {
    const response = await api.delete(`/cna-std-pige-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA STD PIGE file:", error);
    throw error;
  }
};

// Exportar archivos CNA_STD_PIGE_File por ID
export const exportCNASTDPIGEFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/cna-std-pige-files/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA STD PIGE files by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNASTDPIGEFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-std-pige-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CNA STD PIGE files:", error);
    throw error;
  }
};
